<style lang="less">
.ivu-poptip,.ivu-poptip-rel{
  display: block;
}
</style>

<template>
<div class="flex-wrap">
  <template v-if="value || _info.id">
    <Poptip
    padding="0"
    placement="top"
    style="display:block;padding-top:3px;"
    :disabled="disabled"
    popper-class=""
    transfer
    trigger="hover">
       <div class="flex-wrap" style="height:100%" >
           <BaseAvatar v-if="!hideAvatar"  style="background:var(--bg1);color:var(--text1);font-weight:normal;"  :src="_info.avatar" size="small" :style="`line-height:${size}px;marginRight:8px;${size?('height:'+size+'px;width:'+size+'px'):''}`">{{_info && _info.name?_info.name[0]:(value||'-')}}</BaseAvatar>
          <div class="flex-col" style="align-items:flex-start;height:100%;" v-if="!hideInfo">
              <span v-if="!hideName" :style="`font-weight:bold;color:${_info.id?'var(--success)':'red'};${styles}`">{{_info.name || value.slice(0,6)}}</span>
              <slot></slot>
          </div>
      </div>
      <div slot="content" style="background:var(--bg3);padding:10px;padding-right:20px;">
      <div class="flex-wrap" style="align-items:flex-start;" >
        <BaseAvatar :src="_info.avatar" :style="{width:'30px',height:'30px',borderRadius:'50%',marginRight:'8px',lignHeight:size+'px'}">{{_info && _info.name?_info.name[0]:(value||"-")}}</BaseAvatar>
        <div style="margin-left:10px;">
          <div style="font-size:16px;text-align:left;">{{_info.id?_info.name:value}}</div>

          <div><a href="#" @click="RouteTo('/core/deps/'+value,{},true)" style="font-size:12px;">查看动态</a></div>
        </div>
      </div>
  </div>
    </Poptip>
  </template>
  <template v-else>
    <span>无</span>
  </template>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'BaseDepBoard',
  computed: {
    ...mapGetters('session', ['deps']),
    _info() {
      if (this.info) {
        return this.info;
      } else if (this.value) {
        return this.deps.find((v)=>v.id == this.value) || {};
      } else {
        return {};
      }
    },
  },
  mounted() {
    setTimeout(()=>{
      if (this.deps && this.deps.length == 0) {
        this.$store.dispatch('session/getDeps');
      }
    }, 1000);
  },
  props: {
    'value': {
      type: String,
    },
    'info': {
      type: Object,
    },
    'styles': {
      type: String,
    },
    'size': {
      type: Number | String,
      default: 20,
    },
    'hideInfo': {
      type: Boolean,
    },
    'hideName': {
      type: Boolean,
    },
    'hideAvatar': {
      type: Boolean,
    },
    'disabled': {
      type: Boolean,
    },
  },
};
</script>

<style>

</style>
